import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';
import { ensureDocumentQueryData } from '@/features/estate-document/api/document';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents'
)({
  validateSearch: zodValidator(
    z.object({
      order: fallback(z.enum(['asc', 'desc']), 'asc'),
    })
  ),
  loader: ensureDocumentQueryData,
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="documents" /> },
});
